import { Theme } from "@mui/material/styles";
import pxToRem from "assets/theme/functions/pxToRem";
import rgba from "assets/theme/functions/rgba";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    height: "100%",
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    alignItems: "flex-end",
    overflow: "auto",
  },
  bodyContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    flex: 1,
    gap: theme.spacing.spacing8,
    justifyContent: "flex-end",
    paddingBottom: theme.spacing.spacing6,
  },

  consentCard: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: theme.spacing.spacing8,
    borderRadius: pxToRem(16),
    background: (theme.palette.background as { softAlt?: string }).softAlt ?? rgba(theme.palette.primary.main, 0.06),
  },
  consentRow: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
  },
  consentLabel: {
    fontSize: theme.typography.size.xs,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: "18px",
    color: (theme.palette.text as { main?: string }).main ?? theme.palette.text.primary,
    cursor: "pointer",
  },
  termsLink: {
    display: "inline",
    padding: 0,
    margin: 0,
    border: "none",
    background: "transparent",
    font: "inherit",
    fontWeight: theme.typography.fontWeightBold,
    color: (theme.palette.extraColors as { alert?: string })?.alert ?? theme.palette.primary.main,
    cursor: "pointer",
  },
  consentMeta: {
    marginTop: theme.spacing.spacing4,
    fontSize: theme.typography.size.xxs,
    fontWeight: theme.typography.fontWeightRegular,
    color: rgba((theme.palette.text as { main?: string }).main ?? theme.palette.text.primary, 0.6),
    lineHeight: "18px",
    padding: `0 ${theme.spacing.spacing14}`,
  },
  checkBoxLTR: {
    padding: `${theme.spacing.spacing2}  ${theme.spacing.spacing6} ${theme.spacing.spacing2} 0!important`,
  },
  checkBoxRTL: {
    padding: `${theme.spacing.spacing2} 0 ${theme.spacing.spacing2} ${theme.spacing.spacing6}!important`,
  },
});
